<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content stories">
                    <h2 class="crossline-title text-center">Featured Stories</h2>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Jeff and Allison Bobbitt</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-1.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                We bought a brick to show our gratitude to Prosper ISD and our Prosper pride! Our two youngest children have been in the district their entire school experience: Elizabeth “EB” started Prosper ISD in Kindergarten and will graduate class of 2024, and Zelda started in PreK-3 and will graduate class of 2026. We are the Bobbitts, and we are Prosper!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Jay Tollerene</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-2.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Our family loves it here in Prosper and we are excited for our two girls, Blakely and Carmen, to learn and grow at Prosper schools. Sponsoring a brick at the new PISD Stadium is a unique opportunity to support Prosper ISD while also etching our family name into the history of this wonderful community. Such a cool idea, thank you!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Jessica Patterson</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-3.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Jenn has always wanted to be a teacher. She graduated from UNT and has taught in Frisco and Prosper. Jenn was helping a fellow teacher move into her classroom at Folsom and she met the Principal. The Principal interviewed Jenn and just like that she was a Prosper Eagle. Jenn has taught at Folsom and Rucker. She was selected as her schools Teacher of the Year in March 2017. Jenn is an amazing teacher and cares for every one of her kids. She also loves Prosper ISD. She is non stop talking about Dr. Watkins and how great he is. I have never met anyone that is as driven and dedicated as Jenn. She is the first to arrive and last one to leave.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Aly Gwin</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-4.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Having one son play football for the eagles in 2011-2013, having one son in middle school football program now, owning a fitness business in prosper and a health and wellness company in Prosper.. we are so proud to be a Eagle and a part of the Prosper community!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Mary Collins</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-5.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                We are a blended family with four children going through Prosper schools K-12. We love Prosper. Our children love Prosper. We are excited to be here to see such growth. Prosper has certainly changed since we first moved here, but it will always be in our hearts!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Sherri St John</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-6.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                We are excited to be a part of the legacy of building Prosper facilities to match this great school district & to set the tone for years to come. The school spirit & support is infectious & being part of this incredible growth is really exciting for our family.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Steven Gray</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-7.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                The reason I wanted to be part of this is because I am proud to live and raise my children in Prosper. I love the small town feel it still has despite how big it is getting. I absolutely love Friday night lights in Prosper because I get to make wonderful memories with my family. I also get to watch my daughter perform with the band in color guard at halftime. Prosper family forever
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Dalana Squires</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-8.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                All of my children have grown up in Prosper ISD, made life long friends since pre-k, and proudly graduated from PHS, the best school in Texas! The Squires Family is Prosper Proud!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Cecelia & Chuck Foley</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-9.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                As our girls enter the most exciting years of their young lives, we wanted to show them and their school our support for balancing their academics and athletics while having Eagle pride! Fly high and soar girls. Your opportunities are endless. You have the power, knowledge and keen ability to do and be anything. We love you! Love Mom and Dad Foley. We are Prosper!
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Kelly Cutler</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-10.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                I am proud to be a part of the first senior class to enjoy the new stadium. Being a Student Athletic Trainer since my freshman year in 2016 is one of the achievements I am most proud of. The program helped me choose my career path. Once an Eagle, always an Eagle!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Jennifer Peterson</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-11.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                We have four beautiful children, two who have graduated from PHS and two that will in the future! We are excited to be a small part in Prosper with this commemorative brick at the new stadium!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Chris & Jen Sanchez</h3>
                            <p class="text-left">
                                We moved to Prosper with a baby, built a house, had another baby and before we knew it, they were old enough to start school. We thank God for leading us to a small Texas town with a big heart that could take our kids as kindergartners and nurture them through 12th grade. We are privileged to live in a place where not only everyone matters, but kids come first. Lead by Dr. Watkins, PISD has guided, educated, socialized and given our kids everything they need as eagles, even as this small town has grown. As members of the classes of 2021 and 2023, they will be ready to fly and always have the biggest hearts for what really matters in life, no matter where they land. We are forever grateful for that and for all of the memories you've given our family. Thank you, PISD!
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Mark Heussner</h3>
                            <p class="text-left">
                                Our family moved to Mckinney earlier this year and our children have begun their first year in the Prosper ISD. We love this area and know that this is where we wish to stay. We purchased this paver as a reminder to our children that we have their future in our hearts. I say this because our oldest is in 2nd grade, and our youngest is only 2 years old. But as they grow in the Prosper ISD, we want them to always remember to stay strong in their faith, and to be courageous in their lives.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Jeffrey Kunde</h3>
                            <p class="text-left">
                                Since my wife worked in the district before the grandsons were old enough to attend school, pride of everyone there was very obvious. We encouraged our daughter and son-in-law who came from big districts in the area to move to Prosper and experience the excitement and committment that PISD has for the kids. We are so proud to support them in everything they do as they go through their formative years in Prosper ISD: Athletics, Drama & Academics. They will truly be Eagles for Life!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Carley Stiglets</h3>
                            <p class="text-left">
                                Prosper is our home and will always be special to our family. The many special friends we have met along our way, have helped grow and support our 3 priceless boys. We have been involved in preschools, schools, Prosper Sports, Prosper United Methodist Church. Prosper has amazing teachers and leaders that make a difference. We have seen Prosper grow into such a beautiful community. Prosper has so many good, caring and hard working citizens. I am proud to call Prosper our home. God bless Prosper!
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Jill Stillman</h3>
                            <p class="text-left">
                                "Believe you can, and you will" is special to our family because what you say and think is directionally proportional to your actions and ultimately who you become. We have taught our boys to be positive in their thoughts especially in times of adversity and to make sure their decisions show it. Whether it's their academic grades, athletic games or orchestra concerts confidence brings success over failure and giving up is not an option.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Marisol Sandoval-Balderas</h3>
                            <p class="text-left">
                                Our story began in 2009 when mom became a teacher at Folsom Elementary and I, Alexander, was only one month old. I later became part of the Prosper family when I started pre-kinder at Cockrell. Now Mom is the assistant principal at Rucker, and I am in the fourth grade at her school. We love being part of Prosper and can't wait to continue to write our story here for many more years to come.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>William Bray</h3>
                            <p class="text-left">
                                Our inscription is a family saying that simply means YOU can be the light in the darkness that projects joy, happiness, and laughter. Your light also exposes evil hiding in the dark! BE THE LIGHT IN THE CRACK! THE BRAY FAMILY
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Kristie Rockett</h3>
                            <p class="text-left">
                                We moved to Prosper three years ago and are so proud to be a member of this community and school! Excited to be a part of history in the making as Prosper continues to grow! GO Eagles!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Kevin Finnell</h3>
                            <p class="text-left">
                                Our parents Bill and Janice Finnell taught school at Prosper for about 25 yrs and the town and school will always be home for our family. Most of the children graduated from Prosper.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Jennifer Paul</h3>
                            <p class="text-left">
                                We have four children attending and will be attending PISD. We are excited to take part in this program. As we move through the next 18 yrs of school, we can look to our brick with smiles as we attend the games.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Amy Perry</h3>
                            <p class="text-left">
                                It is a graduation gift for each of our boys! Hopefully they will be able to bring their kids back to see it one day. We are so proud of them and proud to be a part of this amazing town- Prosper!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Kathy Trevathan</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-23.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My daughter Lauren Henderson, has been attending Prosper ISD since kindergarten. She’s been a prosper eagle for 12 years. She has been Prosper Talonnette all 4 years of high school. Before high school she was a Eagle Darling.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Johnathan Sicard</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-24.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My name is Johnathan Sicard and I am currently a Sophomore at PHS. I am a snare on the Prosper Drumline. I began on drumline as a freshman. I have been honored to be a part of the award winning marching band finishing in 7th in the State in 2017 and advancing to semifinals in BOA Grand Nationals in 2017. I have also performed as part of an ensemble at the National Percussion Festival in Indianapolis.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Cindy Parker</h3>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-25.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                My family and I moved to Prosper in August of 2007 because we heard of their wonderful school district. When we moved here, there was 4,000 people in the entire city and now there are over 14,000 students in Prosper. My oldest daughter graduated in 2010 and was the first graduating class of the brand new Prosper High School with approximately 200 students in her class. My youngest daughter will graduate in 2021 from that same high school with over 900 students in her class. Cindy has also been fortunate enough to be an employee of this wonderful school district for over 7 years. We have seen a lot of changes to this beautiful town we call home, but the one thing that has always remained the same is Small Town, Small Heart. #weareone The Parkers-Brent, Cindy, LaToya (Marcinko) and Kendall
                            </p>
                        </div>
                    </div>
                    <share-story hr="above"></share-story>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'stories',
        components: {
            'share-story': ShareStory
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Stories.vue?e190288a